import React from 'react';
import { handleEnterKeyToClick } from '../Common/accessibilityHelpers';
import { Modal } from 'react-bootstrap';
import styles from './Vbid.module.scss';

interface Props {
    show: boolean;
    onHideModal: () => void;
}

export const VbidRequestedAppModal = ({ show, onHideModal }: Props) => {
    return (
        <Modal centered show={show} onHide={onHideModal}>
            <div className={styles['success-alert']}>
                <div className={styles['success-modal-container']}>
                    <div className="text-center">
                        <p>
                            Thank you. Your responses have been submitted. <br />You will now be redirected to Alignment
                            Health Plan Member Portal.
                        </p>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            className={styles['modal-btn']}
                            onClick={onHideModal}
                            onKeyUp={handleEnterKeyToClick}
                            tabIndex={0}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
